/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  /**
   * Коллекция для товаров в претензиях по товарам.
   */
  app.ClaimItems = app.ItemPageableCollection.extend({
    model: app.ClaimItem,
    url: function () {
      return app.entryScriptName + '/api/v3/claim-item';
    },
    expand: 'photos,claim_item_response,item,claim_item_reason_types',
    fields: [
      'id',
      'claim_id',
      'item_id',
      'sid',
      'claim_item_status_id',
      'claim_item_reason_title',
      'claim_item_reason_id',
      'claim_item_reason_type_id',
      'order_id',
      'ordered_qty',
      'received_qty',
      'qty',
      'comment',
      'invoice_number',
      'has_photo',
      'item',
      'packaging_type_ids',
      'item.name',
      'item.img',
    ],
    fetchCounter: 0,
    filter: 'null',
    isScroll: false,
    loadFilters: false,
    requestFilters: false,
    state: {
      firstPage: 1,
      pageSize: 50,
      order: 0,
    },
    defaults: {
      pageSize: 50,
      mode: 'server',
    },

    /**
     * Устанавливает параметры запроса
     */
    setQueryParams: function () {
      this.queryParams = {
        claim_id: function () {
          return this.claim_id;
        },
        expand: function () {
          return this.expand;
        },
        fields: function () {
          return this.fields.join(',');
        }
      };
    },
  });
})();

}.call(window));